export default "/_next/static/chunks/fonts/Funnel Display Medium-f7ec2ff731f81ece7b7af9fd0975b28d.ttf";